import React from "react";
import HeadingWithLine from "../../../../../components/HeadingWithLine/HeadingWithLine";
import {
  getPricingName,
  getPricingDataById,
} from "../../../../../../components/helper/helper";
import CrossIconRed from "../../../../../assets/svg/icons/common/CrossIconRed";
import CheckMarkGreen from "../../../../../assets/svg/icons/common/CheckMarkGreen";
import styles from "../../../Application.module.scss";

const ACH_FEES = [
  { key: 51, label: "ACH Statement Fee" },
  { key: 52, label: "ACH Monthly Minimum" },
  { key: 53, label: "ACH Return Fee" },
  { key: 54, label: "ACH NOC Fee" },
  { key: 55, label: "ACH Unauthorized Return Fee" },
  { key: 56, label: "ACH Same Day Fee" },
  { key: 57, label: "ACH Bank Validation Fee" },
];

function Ach({ appData }) {
  const renderYesNo = (value) => {
    if (value !== "" && value !== undefined && value !== null) {
      return value === 1 ? (
        <>
          <CheckMarkGreen /> Yes
        </>
      ) : (
        <>
          <CrossIconRed /> No
        </>
      );
    } else {
      return "-";
    }
  };

  const formatDollars = (value) =>
    value != null && value !== "" ? `$ ${value}` : "-";

  const formatPercent = (value) =>
    value != null && value !== "" ? `${value}%` : "-";

  const achPricing = getPricingDataById(appData, 50);

  return (
    <>
      <div className={styles.ach_pricing_block}>
        <ul>
          <li>
            <div>
              <p>Pricing model</p>
              <p>{getPricingName("ach")}</p>
            </div>
          </li>
        </ul>
      </div>

      <div>
        <ul>
          <li>
            <div>
              <p>Discount rate</p>
              <p>{formatPercent(achPricing.percent)}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Transaction fee per item</p>
              <p>{formatDollars(achPricing.dollars)}</p>
            </div>
          </li>
        </ul>
      </div>

      <div>
        <HeadingWithLine text="Additional Fees" />
        <ul>
          {ACH_FEES.map((fee) => (
            <li key={fee.key}>
              <div>
                <p>{fee.label}</p>
                <p>
                  {formatDollars(getPricingDataById(appData, fee.key).dollars)}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <HeadingWithLine text="ACH Capabilities" />
        <ul>
          <li>
            <div>
              <p>ACH by Phone (TEL)</p>
              <p>{renderYesNo(appData?.billing?.ach_by_phone)}</p>
            </div>
          </li>
          <li>
            <div>
              <p>ACH by Web (WEB)</p>
              <p>{renderYesNo(appData?.billing?.ach_by_web)}</p>
            </div>
          </li>
          <li>
            <div>
              <p>ACH by Pre-authorized Debit (PPD)</p>
              <p>{renderYesNo(appData?.billing?.ach_by_preauth)}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Credit Transaction Capacity (PPD)</p>
              <p>{renderYesNo(appData?.billing?.ach_credit_transaction)}</p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}

export default Ach;
